/* RESPONSIBLE TEAM: team-workflows */

// Custom workflow limits for specific high-volume workspaces
export const CUSTOM_WORKFLOW_LIMITS: Record<number | string, number> = {
  v7g38gws: 6000,
  qwum5ehb: 2000,
  w4slywic: 2000,
  u2d2x9ar: 1500,
  p8a06sgu: 1500,
};

export const DEFAULT_WORKFLOW_LIMIT = 1000;

export function getWorkflowLimit(appId: number | string | undefined): number {
  if (!appId) {
    return DEFAULT_WORKFLOW_LIMIT;
  }
  return CUSTOM_WORKFLOW_LIMITS[appId] ?? DEFAULT_WORKFLOW_LIMIT;
}
